<template>
  <div class="position-absolute start-0 top-0 w-100 h-100 bg-opacity-50 bg-white d-flex flex-column align-items-center justify-content-center">
    <slot />
  </div>
</template>

